import { useEffect, useState } from "react";
import { FirebaseDataService } from "src/services/Firebase/data";

export const useTestGroup = (email: string | undefined): boolean => {
  const [testGroupEmails, setTestGroupEmails] = useState<string[]>([]);

  useEffect(() => {
    FirebaseDataService.getTestGroup()
      .then((result) => {
        const emails = Object.values(result.data || {}) as unknown as string[];
        setTestGroupEmails(emails);
      })
      .catch(() => setTestGroupEmails([]));
  }, []);

  return testGroupEmails.includes(email ?? "");
};
